import { ErrorLogComponent } from '@cian/error-log-component';
import { Provider as MicrofrontendProvider } from '@cian/mf-react';
import { UiKitContextProvider } from '@cian/ui-kit/context';
import * as React from 'react';
import { Provider } from 'react-redux';

import { normalizeDeviceType } from './utils/normalizeDeviceType';
import { IApplicationContext } from '../../types/application';
import { TReduxStore } from '../../types/redux';
import { HighlightingProvider } from '../../utils/highlightingProvider';
import { ApplicationContext } from '../ApplicationContext';
import { Page } from '../Page';
import { ServicesPage } from '../ServicesPage';

export interface IApplicationProps {
  context: IApplicationContext;
  reduxStore: TReduxStore;
}

const SERVICES_PATH = '/services';

export const Application: React.FC<IApplicationProps> = ({ reduxStore, context }) => {
  const { microfrontendsRegistry, custom } = context;

  return (
    <ErrorLogComponent logger={context.logger}>
      <ApplicationContext.Provider value={context}>
        <UiKitContextProvider deviceType={normalizeDeviceType(context.custom.deviceType)}>
          <MicrofrontendProvider registry={microfrontendsRegistry}>
            <Provider store={reduxStore}>
              <HighlightingProvider>{custom.path === SERVICES_PATH ? <ServicesPage /> : <Page />}</HighlightingProvider>
            </Provider>
          </MicrofrontendProvider>
        </UiKitContextProvider>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};
